<template>
  <van-collapse v-model="activeName" accordion>
    <van-collapse-item
      v-for="(item, index) in list"
      :name="index"
      :key="index"
      :title="item.contactsName"
    >
      <div class="content">
        <div class="list">
          <span class="list-left">奖品类型</span>
          <span class="list-right">{{ item.prizeType }}</span>
        </div>
        <div class="list">
          <span class="list-left">名称</span>
          <span class="list-right">{{ item.prizeName }}</span>
        </div>
        <div class="list">
          <span class="list-left">兑换时间</span>
          <span class="list-right">{{ item.createdTime }}</span>
        </div>
        <div class="list">
          <span class="list-left">兑换人手机号</span>
          <span class="list-right">{{ item.contactsPohone }}</span>
        </div>
        <div class="list">
          <span class="list-left">省市区</span>
          <span class="list-right">{{ item.province }}</span>
        </div>
        <div class="list">
          <span class="list-left">详细地址</span>
          <span class="list-right">{{ item.address }}</span>
        </div>
        <div class="list">
          <span class="list-left">运单号</span>
          <span class="list-right">{{ item.expressNo }}</span>
        </div>
      </div>
    </van-collapse-item>
  </van-collapse>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      activeName: [],
    };
  },
};
</script>
<style lang="stylus" scoped>
.content {
  .list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 10px 0;
    color: #999999;
    font-size: 14px;
    .list-right {
      position relative
      display: flex;
      justify-content: flex-end;
      align-items: center;
      width: 230px;
      flex-wrap: wrap;
      color: #333333;
    }
  }
}
</style>
